<div class="flex gap-2">
  <div>
    <p-toggleswitch [(ngModel)]="isChecked" (onChange)="handleChange()" [disabled]="isDisabled()"/>
  </div>
  @if (title()) {
    <div class="flex flex-column">
      <div [class]="styleClass() ?? 'text-sm-medium text-gray-700'">{{ title() }}</div>
      @if (additionalText()) {
        <div class="text-sm-regular">{{ additionalText() }}</div>
      }
    </div>
  }
</div>
